import { render, staticRenderFns } from "./HighlightedServicesCard.vue?vue&type=template&id=bbb21f9a&"
import script from "./HighlightedServicesCard.vue?vue&type=script&lang=js&"
export * from "./HighlightedServicesCard.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedServicesCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports